import { ModalProps } from '@mantine/core';

export const PROMPT_BASE_PRESETS: Partial<ModalProps> = {
  centered: true,
  padding: 'xs',
  returnFocus: false,
};
